// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type Action,
	createActionsHook,
	createContainer,
	createStateHook,
	createStore,
} from '@atlassian/react-sweet-state';
import type { ContainerProps, State, UpdateJqlProps } from './types.tsx';
import { getStateFromJQL } from './utils.tsx';

const initialState = {
	ast: {
		query: undefined,
		represents: '',
		errors: [],
	},
	clauseMap: {},
	jql: '',
	textSearchInputClause: undefined,
	anonymizedJql: '',
	isModeSwitcherEnabled: false,
};

export const AstContainer = createContainer<ContainerProps>();

const Store = createStore({
	containedBy: AstContainer,
	initialState,
	actions: {
		updateJql:
			({ jql, fieldType, amountOfSelectedOptionsOfFieldType }: UpdateJqlProps) =>
			({ setState }, { onJqlChange, isModeSwitcherEnabled }) => {
				const updatedResult = getStateFromJQL(jql, isModeSwitcherEnabled);
				setState(updatedResult);
				onJqlChange && onJqlChange(jql, fieldType, amountOfSelectedOptionsOfFieldType);
			},
	},
	handlers: {
		onInit:
			(): Action<State, ContainerProps> =>
			({ setState }, { defaultJql, isModeSwitcherEnabled }) => {
				setState(getStateFromJQL(defaultJql, isModeSwitcherEnabled));
			},
		onContainerUpdate:
			(nextProps, prevProps): Action<State, ContainerProps> =>
			({ setState }) => {
				if (nextProps.defaultJql !== prevProps.defaultJql) {
					setState(getStateFromJQL(nextProps.defaultJql, nextProps.isModeSwitcherEnabled));
				}
			},
	},
	name: 'jira-filter-refinement-ast',
});

export const useASTActions = createActionsHook(Store);

export const useAST = createStateHook(Store, {
	selector: ({ ast }) => ast,
});

export const useJQL = createStateHook(Store, {
	selector: ({ jql }) => jql,
});

/**
 * @deprecated use `useClausesForField` instead
 */
export const useClauseMap = createStateHook(Store, {
	selector: ({ clauseMap }) => clauseMap,
});

/**
 * @deprecated use `useTextSearchInputClause` from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/use-text-search-input-clause.tsx' instead
 * delete useTextSearchInputClause when cleanup shplxi_628_cleanup fg
 */
export const useTextSearchInputClause = createStateHook(Store, {
	selector: ({ textSearchInputClause }) => textSearchInputClause,
});

/**
 * Returns anonymizedJql which is UGC safe
 */
export const useAnonymizedJql = createStateHook(Store, {
	selector: ({ anonymizedJql }) => anonymizedJql,
});

/**
 * True if the jql is not empty or whitespace only
 */
export const useHasJql = createStateHook(Store, {
	selector: ({ jql }) => Boolean(jql.trim()),
});
